import workspaceQuery from '../../../graphql/queries/bank/BankRevaluationWorkspaceQuery.graphql';
import instanceQuery from '../../../graphql/queries/bank/BankRevaluationQuery.graphql';
import defaultQuery from '../../../graphql/queries/bank/BankRevaluationDefault.graphql';
import mutationQuery from '../../../graphql/mutations/bank/BankRevaluationMutation.graphql';
import temporaryMutationQuery from '../../../graphql/mutations/bank/SaveBankRevaluationTempMutation.graphql';
import fragment from '../../../graphql/fragments/bank/BankRevaluationFragment.graphql';
import { ALLOW_ADD, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const BankRevaluation = {
  type: 'BankRevaluation',
  title: 'Currency Revaluation',
  formUrl: '/Bank/Revaluation/Details/',
  formTitle: 'Currency Revaluation',
  workspaceUrl: '/Bank/Revaluation/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  screenReference: 'BANK_REVALUATION',
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED'],
    },
  ],
  operations: ALLOW_ADD | ALLOW_VIEW,
};

export default BankRevaluation;
